/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GalleryDto } from '../../models/gallery-dto';
import { UpdateGalleryDto } from '../../models/update-gallery-dto';

export interface GalleryControllerUpdateV1$Params {
  id: string;
      body: UpdateGalleryDto
}

export function galleryControllerUpdateV1(http: HttpClient, rootUrl: string, params: GalleryControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryDto>> {
  const rb = new RequestBuilder(rootUrl, galleryControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GalleryDto>;
    })
  );
}

galleryControllerUpdateV1.PATH = '/api/v1/gallery/{id}';
